import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-responsive-modal'

export default class RenewModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    mark: PropTypes.object,
    onRenewMark: PropTypes.func.isRequired,
    renewErrors: PropTypes.string
  }

  constructor (props) {
    super(props)
  }

  render () {
    const {
      show,
      onClose,
      mark,
      onRenewMark,
      renewErrors
    } = this.props
    return (
      <Modal
        open={show}
        onClose={onClose}
        showCloseIcon
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{modal: 'container'}}
      >
        <h3>Rinnova Contrassegno</h3>

        {mark ? (
          <div>
            <div className="row">
              <div className="col-md-7 col-xs-12">
                <div className="user-card">
                  <div className="user-card-head-a">
                    <h5 className="user-card-title">
                      CONTRASSEGNO
                    </h5>
                  </div>
                  <div className="user-card-body">
                    <div className="row">
                      <div style={{padding: 0, marginBottom: 5}} className="col-md-6">
                        <strong>{mark.MarkType.name + ' ' + mark.Category.label.toUpperCase()}</strong>
                      </div>
                      <div style={{padding: 0}} className="col-md-6 text-right">
                        ZON{mark.MarkType.Areas.length > 1 ? 'E' : 'A'} <strong>{mark.MarkType.Areas.map(item => item.code + ' ')}</strong>
                      </div>
                      <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                        {mark.fatherMark && <span>DERIVATO DA CONTRASSEGNO N.: <strong>{mark.id}</strong></span>}
                      </div>
                      <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                        <span>TARG{mark.Vehicles.length > 1 ? 'HE' : 'A'}: <strong>{mark.Vehicles.map(item => item.plate_number + ' ')}</strong></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-xs-12">
                <p>
                  Da qui puoi richiedere il rinnovo del tuo contrassegno <strong>N. {mark.id}</strong> attivo {mark.Vehicles.length > 1 ? 'sui veicoli' : 'sul veicolo'}: <strong>{mark.Vehicles.map(item => item.plate_number + ' ')}</strong>.<br />
                  Per confermare la richiesta clicca: "Conferma Richiesta"
                </p>
              </div>
            </div>
            <div className="row">
              {renewErrors && (
                <div className="col-md-12 text-danger text-center" style={{marginBottom: '15px', marginTop: '10px'}}>
                  {renewErrors}
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-6 col-xs-12" style={{marginBottom: '15px', marginTop: '10px'}}>
                <a className="btn-download-user" style={{backgroundColor: '#eb242e'}} onClick={onClose}>Annulla</a>{' '}
                <a className="btn-download-user" onClick={() => onRenewMark(mark)}>Conferma Richiesta</a>
              </div>
            </div>
          </div>
        ) : (
          <div>Dati non disponibili</div>
        )}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RenewModal.js